import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects'
import selectIdToken from '../selectors/select-id-token'
import {
  FetchCustomerAlarmsAction,
  FetchCustomerAlarmsFailAction,
  FetchCustomerAlarmsSuccessAction,
  SaveCustomerAlarmsAction,
  SaveCustomerAlarmsSuccessAction
} from './setting-actions'
import { type FetchCompanyAlarmsPayload, type FetchCompanyAlarmsSuccessPayload } from './settings-type'
import { selectFromState } from '../selectors/select-from-state'
import { type CompanyAlarmSettingsResponse, CompanyApi } from '../../api/company-api'
import { AddMessageAction } from '../messages/messages-actions'
import { MessageTypes } from '../messages/messages-types'

/* Sage Generator Functions */

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function * fetchCompanyAlarmSettings(action: { payload: FetchCompanyAlarmsPayload }) {
  const companyId = action.payload.id

  // note: 'select' function do not work well with TypeScript types
  // (i.e. the return value do not reflect the correct type)
  const idToken: ReturnType<typeof selectIdToken> = yield selectFromState(selectIdToken)
  const response: CompanyAlarmSettingsResponse = yield call(CompanyApi.getAlarmSettings, idToken, companyId)

  if (response.succeeded) {
    yield put(FetchCustomerAlarmsSuccessAction({
      id: companyId,
      data: response.payload
    }))
  } else {
    yield all([
      put(FetchCustomerAlarmsFailAction()),
      put(AddMessageAction(
        response.errorKey ?? 'companies.fetchAlarmSettingsFailedDefaultError',
        MessageTypes.error))
    ])
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function * saveCompanyAlarmSettings(action: { payload: FetchCompanyAlarmsSuccessPayload }) {
  const companyId = action.payload.id
  const alarmSettings = action.payload.data

  // note: 'select' function do not work well with TypeScript types
  // (i.e. the return value do not reflect the correct type)
  const idToken: ReturnType<typeof selectIdToken> = yield selectFromState(selectIdToken)
  const response: CompanyAlarmSettingsResponse = yield call(CompanyApi.updateAlarmSettings, idToken, companyId, alarmSettings)

  if (response.succeeded) {
    yield put(SaveCustomerAlarmsSuccessAction({ id: companyId, data: response.payload }))
  } else {
    yield put(AddMessageAction(
      response.errorKey ?? 'companies.updateAlarmSettingsFailedDefaultError',
      MessageTypes.error))
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function * settingsSagas() {
  yield takeLatest(FetchCustomerAlarmsAction, fetchCompanyAlarmSettings)
  yield takeEvery(SaveCustomerAlarmsAction, saveCompanyAlarmSettings)
}
